import { Currency } from '@/core/currency/interfaces';

const CZK: Currency = {
    name: 'Czech Koruna',
    demonym: 'Czech',
    majorSingle: 'Koruna',
    majorPlural: 'Koruny',
    codeNumeric: '203',
    symbol: 'Kč',
    symbolNative: 'Kč',
    minorSingle: 'Haléř',
    minorPlural: 'Haléř',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'CZK',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default CZK;
